import React, { useEffect, useState, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import "./AddVenue.css";
import ImageReact from "../../components/Image";
import MapComponent from "../../components/Map";
import MultiSelectDropdown from "../../components/MultiSelectDropdown/MultiSelectDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import CurrentStep from "./CurrentStep";
import Loading from "../../components/Loader";
import { ToastContainer, toast } from "react-toastify";
import img from "../../assets/images/error.png";
import Success from "./Success";
import AuthContext from "../../contexts/AuthProvider";

import { API_URL } from "../../utils/config";
const baseUrl = API_URL;

const StepOne = ({
  old,
  setNew,
  New,
  setOld,
  convertFallbackImageToPNG,
  convertImageUrlToFile,
  images,
  setFiles,
  status,
  setStatus,
  update,
  files,
}) => {
  const { t } = useTranslation("addvenue");
  const navigate = useNavigate();
  const location = useLocation();
  const [isUploadingFiles, setIsUploadingFiles] = useState(false);
  const [fileProcessingErrors, setFileProcessingErrors] = useState(0);
  const fileInputRef = useRef(null);
  const { isAuthenticated } = useContext(AuthContext);
  
  // Focus point functionality
  const [imageFocus, setImageFocus] = useState({});
  const [focusOverlay, setFocusOverlay] = useState({
    show: false,
    image: null,
    type: "new",
  });
  const [focusPoint, setFocusPoint] = useState({ x: 50, y: 50 });
  const [isDragging, setIsDragging] = useState(false);
  const overlayRef = useRef(null);
  
  // Target dimensions for overlay display
  const TARGET_WIDTH = 1700;
  const TARGET_HEIGHT = 450;
  const TARGET_ASPECT_RATIO = TARGET_WIDTH / TARGET_HEIGHT;

  // Helper function to ensure files array is always flat (no nested arrays)
  const flattenFiles = (filesArray) => {
    if (!Array.isArray(filesArray)) {
      return filesArray ? [filesArray] : [];
    }
    const flattened = [];
    filesArray.forEach((item) => {
      if (Array.isArray(item)) {
        // If item is an array, spread it into the flattened array
        flattened.push(...item);
      } else if (item !== null && item !== undefined) {
        // If item is a single file/string, add it directly
        flattened.push(item);
      }
    });
    return flattened;
  };

  const handleNavigateWithParams = (step) => {
    if (confirm()) {
      navigate({
        pathname: location.pathname,
        search: `?step=${step}`,
      });
    }
  };
  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  const currentYear = new Date().getFullYear();

  const confirm = () => {
    return (
      state.name.trim() &&
      state.size &&
      state.city &&
      state.year &&
      state.country &&
      state.latitude &&
      state.longitude &&
      state.brand &&
      state.venue_type_id &&
      state.year <= currentYear &&
      files.length > 0 &&
      state.capacity >= 1 &&
      state.year >= 1800 &&
      state.size > 0 &&
      state.guest_rooms >= 0 &&
      state.terms
    );
  };

  useEffect(() => {
    if (status === "Success") {
      const timer = setTimeout(() => {
        setStatus("");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  const [center, setCenter] = useState({ lat: 24.7136, lng: 46.6753 });
  const [searchCity, setSearchCity] = useState("");
  const [locationName, setLocationName] = useState("");

  const initialState = {
    previews: images || [],
    name: "",
    brand: "",
    year: null,
    capacity: null,
    guest_rooms: null,
    size: null,
    venue_type_id: "",
    country: "",
    city: null,
    terms: "",
    latitude: center.lat,
    longitude: center.lng,
  };

  const searchParams = new URLSearchParams(location.search);
  const [editVenue, setEditVenue] = useState(
    searchParams.get("edit") === "true"
  );

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      latitude: center.lat,
      longitude: center.lng,
    }));
  }, [center]);

  const [state, setState] = useState(() => {
    const saved = localStorage.getItem("appState");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch {
        return initialState;
      }
    }
    return initialState;
  });

  useEffect(() => {
    localStorage.setItem("appState", JSON.stringify(state));
  }, [state]);

  // Save location name to localStorage when it changes
  useEffect(() => {
    if (locationName) {
      localStorage.setItem("locationName", locationName);
    }
  }, [locationName]);

  const updateState = (key, value) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const [venueTypesList, setVenueTypesList] = useState([]);
  const [eventTypesList, setEventTypesList] = useState([]);
  const [selectedEventTypes, setSelectedEventTypes] = useState(() => {
    try {
      const saved = localStorage.getItem("selectedEventTypes");
      const parsed = saved ? JSON.parse(saved) : [];
      return Array.isArray(parsed) ? parsed.map((x) => (typeof x === "number" ? x : parseInt(x, 10))).filter((n) => !isNaN(n)) : [];
    } catch {
      return [];
    }
  });
  const countries = [
    { id: 1, name: "Saudi Arabia" },
  ];

  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (!isAuthenticated) return;
    fetch(`${baseUrl}/api/v1/cities`, {
      credentials: "include",
      headers: { Accept: "application/json", lang: getLangFromLocalStorage() },
    })
      .then((res) => {
        if (!res.ok) throw new Error(t("errorFetchCities"));
        return res.json();
      })
      .then((data) => setCities(data.data || data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}/api/v1/venue-types`, {
      credentials: "include",
      headers: { Accept: "application/json", lang: getLangFromLocalStorage() },
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error("Failed to fetch venue types"))))
      .then((data) => setVenueTypesList(data.data || data || []))
      .catch(() => setVenueTypesList([]));
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}/api/v1/event-types`, {
      credentials: "include",
      headers: { Accept: "application/json", lang: getLangFromLocalStorage() },
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error("Failed to fetch event types"))))
      .then((data) => setEventTypesList(data.data || data || []))
      .catch(() => setEventTypesList([]));
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedEventTypes", JSON.stringify(selectedEventTypes));
  }, [selectedEventTypes]);

  useEffect(() => {
    const storedFiles = JSON.parse(sessionStorage.getItem("files")) || [];
    if (storedFiles.length) {
      const reconstructedFiles = storedFiles
        .map((fileData) => {
          if (!fileData || !fileData.base64) return null;
          try {
            const base64Data = fileData.base64.split(",")[1] || fileData.base64;
            const byteChars = atob(base64Data);
            const byteNumbers = new Array(byteChars.length);
            for (let i = 0; i < byteChars.length; i++) {
              byteNumbers[i] = byteChars.charCodeAt(i);
            }
            const bytes = new Uint8Array(byteNumbers);
            return new File([bytes], fileData.name, { type: fileData.type });
          } catch (error) {
            console.error("Error reconstructing file:", error);
            return null;
          }
        })
        .filter(Boolean);

      if (reconstructedFiles.length) {
        const flatFiles = flattenFiles(reconstructedFiles);
        setFiles(flatFiles);
        updateState(
          "previews",
          flatFiles.map((f) => URL.createObjectURL(f))
        );
      }
    }
  }, []);

  const handleFileError = (error) => {
    console.error("File processing error:", error);
    toast.error(
      t("fileProcessingError") || "Error processing files. Please try again.", 
      { autoClose: 5000 }
    );
    if (fileInputRef.current) fileInputRef.current.value = "";
    setIsUploadingFiles(false);
  };

  const handleFileChange = async (e) => {
    setStatus("");
    setIsUploadingFiles(true);

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
    ];

    const allSelected = Array.from(e.target.files);
    const currentImageCount = files.length;
    const maxImages = 7;
    
    // Check if adding these files would exceed the limit
    if (currentImageCount >= maxImages) {
      toast.error(
        t("maxImagesReached") || `Maximum ${maxImages} images allowed. Please remove an image first to add a new one.`, 
        { autoClose: 5000 }
      );
      setIsUploadingFiles(false);
      e.target.value = "";
      return;
    }
    
    // First filter for valid file types from all selected files
    const validFiles = allSelected.filter((f) => allowedTypes.includes(f.type));
    const invalidFiles = allSelected.filter((f) => !allowedTypes.includes(f.type));

    // Show error for invalid files with allowed types
    if (invalidFiles.length > 0) {
      const allowedTypesText = t("allowedImageTypes") || "Allowed types: PNG, JPEG, JPG, GIF, WEBP";
      toast.error(
        `${t("invalidImageTypes") || "Invalid image types selected"}. ${allowedTypesText}`, 
        { autoClose: 5000 }
      );
    }

    if (validFiles.length === 0) {
      setIsUploadingFiles(false);
      e.target.value = "";
      return;
    }

    // Now limit the valid files to remaining slots
    const remainingSlots = maxImages - currentImageCount;
    const filesToAdd = validFiles.slice(0, remainingSlots);
    
    if (validFiles.length > remainingSlots) {
      toast.warning(
        t("someImagesSkipped") || `You selected ${validFiles.length} images, but only ${remainingSlots} can be added (${currentImageCount} already uploaded, maximum ${maxImages} total).`, 
        { autoClose: 5000 }
      );
    }

    if (filesToAdd.length > 0) {
      try {
        // Process all files and add them individually to ensure they're separate entries
        const processedFiles = [];
        const processedPreviews = [];
        const processedMetadata = [];

        // Process files one by one to ensure they're added individually
        for (const file of filesToAdd) {
          await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              processedFiles.push(file);
              processedPreviews.push(URL.createObjectURL(file));
              processedMetadata.push({
                name: file.name,
                type: file.type,
                size: file.size,
                lastModified: file.lastModified,
              });
              resolve(null);
            };
            reader.onerror = () => {
              setFileProcessingErrors((prev) => prev + 1);
              resolve(null);
            };
            reader.readAsDataURL(file);
          });
        }

        // Add each file individually to the files array (not as nested arrays)
        if (editVenue) {
          setNew((prev) => {
            const currentFiles = flattenFiles(prev);
            return [...currentFiles, ...processedFiles];
          });
        }
        
        setFiles((prev) => {
          const currentFiles = flattenFiles(prev);
          return [...currentFiles, ...processedFiles];
        });

        updateState("previews", [...state.previews, ...processedPreviews]);

        const stored = JSON.parse(sessionStorage.getItem("files")) || [];
        sessionStorage.setItem(
          "files",
          JSON.stringify([...stored, ...processedMetadata])
        );
      } catch (error) {
        handleFileError(error);
      } finally {
        setIsUploadingFiles(false);
        e.target.value = "";
      }
    } else {
      setIsUploadingFiles(false);
      e.target.value = "";
    }
  };

  const removeFile = (idx) => {
    if (state.previews[idx]?.startsWith("blob:")) {
      URL.revokeObjectURL(state.previews[idx]);
    }
    const newPreviews = state.previews.filter((_, i) => i !== idx);
    updateState("previews", newPreviews);

    if (editVenue) {
      const removedFile = files[idx];
      if (removedFile) {
        if (typeof removedFile === "string" && removedFile.startsWith("http")) {
          setOld((prev) => [...prev, removedFile]);
        } else if (New.includes(removedFile)) {
          setNew((prev) => prev.filter((file) => file !== removedFile));
        }
      }
    }

    // Remove focus data for this image
    const imageKey = typeof files[idx] === "string" ? files[idx] : files[idx]?.name;
    if (imageKey && imageFocus[imageKey]) {
      const newFocus = { ...imageFocus };
      delete newFocus[imageKey];
      setImageFocus(newFocus);
    }

    setFiles((prev) => {
      const flatFiles = flattenFiles(prev);
      return flatFiles.filter((_, i) => i !== idx);
    });
    const stored = JSON.parse(sessionStorage.getItem("files")) || [];
    stored.splice(idx, 1);
    sessionStorage.setItem("files", JSON.stringify(stored));
  };

  const [loading, setLoading] = useState(editVenue);
  const [error, setError] = useState(null);
  const id = localStorage.getItem("venueId");

  useEffect(() => {
    setEditVenue(searchParams.get("edit") === "true");
  }, [searchParams]);

  useEffect(() => {
    const fetchVenues = async () => {
      if (!isAuthenticated) {
        setError(new Error(t("error")));
        setLoading(false);
        navigate("/");
        return;
      }
      try {
        const resp = await fetch(`${baseUrl}/api/v1/attnd-venue/venues/${id}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),
          },
        });
        if (!resp.ok) {
          if (resp.status === 401) {
            navigate("/login");
            throw new Error(t("error"));
          } else if (resp.status === 404) {
            alert("404 Not found.");
            navigate(-1);
            throw new Error("404 Not found.");
          } else {
            throw new Error(`An error occurred: ${resp.statusText}`);
          }
        }
        const venue = await resp.json();
        const d = venue.venue_details;
        const cityId = cities.find((city) => city.name === d.city)?.id || null;
       console.log("Fetched venue data:", d);
        const initial = {
          previews: d.images,
          name: d.name,
          brand: d.brand,
          year: d.build,
          capacity: d.capacity,
          guest_rooms: d.guest_rooms,
          size: d.size,
          venue_type_id: d.venue_type?.id ?? d.venue_type_id ?? "",
          country: 1,
          city: cityId,
          terms: d.terms_and_conditions,
          latitude: d.latitude,
          longitude: d.longitude,
        };
        setState(initial);
        // Load event types from venue
        const eventTypeIds = (d.event_types || []).map((et) => et.id).filter((id) => id != null);
        setSelectedEventTypes(eventTypeIds);
        // Ensure images is always a flat array (not nested)
        const imagesArray = flattenFiles(d.images || []);
        setFiles(imagesArray);
        // Set location name from the venue data
        setLocationName(d.location || d.city ||  "");
        setLoading(false);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (editVenue && status !== "loading") fetchVenues();
  }, [baseUrl, status, cities]);

  // Focus point functionality
  const openFocusSelector = (preview, index) => {
    const imageKey = typeof files[index] === "string" ? files[index] : files[index]?.name || `preview-${index}`;
    const currentFocus = imageFocus[imageKey] || { x: 50, y: 50 };
    setFocusPoint(currentFocus);
    setFocusOverlay({ 
      show: true, 
      image: preview, 
      imageKey,
      index
    });
  };

  const closeFocusSelector = () => {
    if (focusOverlay.imageKey) {
      setImageFocus({
        ...imageFocus,
        [focusOverlay.imageKey]: focusPoint,
      });
    }
    setFocusOverlay({ show: false, image: null, imageKey: null, index: null });
    setIsDragging(false);
  };

  const handleResetFocus = () => {
    setFocusPoint({ x: 50, y: 50 });
  };

  const getPositionFromEvent = (event) => {
    if (!overlayRef.current) return null;

    const rect = overlayRef.current.getBoundingClientRect();
    let clientX, clientY;

    if (event.type.includes("touch")) {
      clientX = event.touches[0]?.clientX || event.changedTouches[0]?.clientX;
      clientY = event.touches[0]?.clientY || event.changedTouches[0]?.clientY;
    } else {
      clientX = event.clientX;
      clientY = event.clientY;
    }

    const x = ((clientX - rect.left) / rect.width) * 100;
    const y = ((clientY - rect.top) / rect.height) * 100;

    return {
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y)),
    };
  };

  const handleMouseDown = (event) => {
    event.preventDefault();
    setIsDragging(true);
    const position = getPositionFromEvent(event);
    if (position) {
      setFocusPoint(position);
    }
  };

  const handleMouseMove = (event) => {
    if (!isDragging) return;
    event.preventDefault();
    const position = getPositionFromEvent(event);
    if (position) {
      setFocusPoint(position);
    }
  };

  const handleMouseUp = (event) => {
    if (isDragging) {
      event.preventDefault();
      setIsDragging(false);
    }
  };

  const handleTouchStart = (event) => {
    event.preventDefault();
    setIsDragging(true);
    const position = getPositionFromEvent(event);
    if (position) {
      setFocusPoint(position);
    }
  };

  const handleTouchMove = (event) => {
    if (!isDragging) return;
    event.preventDefault();
    const position = getPositionFromEvent(event);
    if (position) {
      setFocusPoint(position);
    }
  };

  const handleTouchEnd = (event) => {
    if (isDragging) {
      event.preventDefault();
      setIsDragging(false);
    }
  };

  // Add global event listeners for mouse events when dragging
  useEffect(() => {
    if (isDragging) {
      const handleGlobalMouseMove = (e) => handleMouseMove(e);
      const handleGlobalMouseUp = (e) => handleMouseUp(e);
      const handleGlobalTouchMove = (e) => handleTouchMove(e);
      const handleGlobalTouchEnd = (e) => handleTouchEnd(e);

      document.addEventListener("mousemove", handleGlobalMouseMove);
      document.addEventListener("mouseup", handleGlobalMouseUp);
      document.addEventListener("touchmove", handleGlobalTouchMove, {
        passive: false,
      });
      document.addEventListener("touchend", handleGlobalTouchEnd);

      return () => {
        document.removeEventListener("mousemove", handleGlobalMouseMove);
        document.removeEventListener("mouseup", handleGlobalMouseUp);
        document.removeEventListener("touchmove", handleGlobalTouchMove);
        document.removeEventListener("touchend", handleGlobalTouchEnd);
      };
    }
  }, [isDragging, focusPoint]);

  const saveFocusPoint = () => {
    if (focusOverlay.imageKey) {
      setImageFocus({
        ...imageFocus,
        [focusOverlay.imageKey]: focusPoint,
      });
    }
    closeFocusSelector();
  };

  const getImageStyle = (imageKey) => {
    const focus = imageFocus[imageKey];
    if (!focus) return {};

    return {
      objectPosition: `${focus.x}% ${focus.y}%`,
    };
  };

  const getFocusPreview = (imageKey) => {
    const focus = imageFocus[imageKey];
    if (!focus) return null;

    return (
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none" }}>
        <div
          style={{
            position: "absolute",
            width: "8px",
            height: "8px",
            backgroundColor: "#3b82f6",
            borderRadius: "50%",
            transform: "translate(-50%, -50%)",
            border: "2px solid white",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
            left: `${focus.x}%`,
            top: `${focus.y}%`,
          }}
        />
      </div>
    );
  };

  if (loading)
    return (
      <div
        style={{
          height: "calc(100vh - 400px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loading />
      </div>
    );
  if (error)
    return <div className="venue-venues-container">Error: {error.message}</div>;

  return (
    <div className="steps" style={editVenue ? { margin: "0" } : {}}>
      <CurrentStep step={1} />

      <h5 className="Cover" style={editVenue ? { margin: "0" } : {}}>
        {t("coverImages")} <span style={{ color: "red" }}>*</span>
        <span style={{ 
          fontSize: "14px", 
          fontWeight: "normal", 
          color: "#666", 
          marginLeft: "8px" 
        }}>
          ({files.length}/7)
        </span>
      </h5>
      <div className="Images">
        {state.previews.map((preview, index) => {
          const imageKey = typeof files[index] === "string" ? files[index] : files[index]?.name || `preview-${index}`;
          return (
            <div key={index} className="Preview" style={{ 
              position: "relative",
              border: "1px solid #dbdbdb",
              width: "172px",
              height: "132px",
              overflow: "hidden",
              borderRadius: "4px"
            }}>
              <ImageReact 
                src={preview} 
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  transition: "transform 0.2s",
                  ...getImageStyle(imageKey)
                }}
                alt={`Venue image ${index + 1}`}
              />
              {getFocusPreview(imageKey)}
              
              {/* Action buttons */}
              <div 
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  display: "flex",
                  gap: "4px"
                }}
                className="preview-actions"
              >
                <button
                  style={{
                    backgroundColor: "#3b82f6",
                    color: "white",
                    padding: "6px",
                    borderRadius: "6px",
                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    border: "none",
                    cursor: "pointer",
                    opacity: 1,
                    transition: "all 0.2s ease-in-out",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  className="focus-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    openFocusSelector(preview, index);
                  }}
                  title={t("setFocusPoint") || "Set focus point"}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#2563eb";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#3b82f6";
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <line
                      x1="12"
                      y1="2"
                      x2="12"
                      y2="6"
                      stroke="white"
                      strokeWidth="2"
                    />
                    <line
                      x1="12"
                      y1="18"
                      x2="12"
                      y2="22"
                      stroke="white"
                      strokeWidth="2"
                    />
                    <line
                      x1="2"
                      y1="12"
                      x2="6"
                      y2="12"
                      stroke="white"
                      strokeWidth="2"
                    />
                    <line
                      x1="18"
                      y1="12"
                      x2="22"
                      y2="12"
                      stroke="white"
                      strokeWidth="2"
                    />
                  </svg>
                </button>
                <button
                  style={{
                    backgroundColor: "#ef4444",
                    color: "white",
                    padding: "6px",
                    borderRadius: "6px",
                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    border: "none",
                    cursor: "pointer",
                    opacity: 1,
                    transition: "all 0.2s ease-in-out",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  className="delete-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFile(index);
                  }}
                  title={t("deleteImage") || "Delete image"}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#dc2626";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#ef4444";
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14zM10 11v6M14 11v6"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>
            </div>
          );
        })}
        {files.length < 7 && (
          <div style={{ margin: "0", position: "relative" }}>
            <label style={{ cursor: "pointer" }}>
              <div>
                <div>
                  {isUploadingFiles ? (
                    <Loading />
                  ) : (
                    <img src="/Frame 335481.svg" alt="Upload new image" />
                  )}
                </div>
                <input
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  type="file"
                  name="logo"
                  accept="image/png,image/jpeg,image/jpg,image/webp"
                  onChange={handleFileChange}
                  multiple
                  disabled={isUploadingFiles}
                />
              </div>
            </label>
            {!isUploadingFiles && files.length > 0 && (
              <div style={{
                position: "absolute",
                bottom: "-20px",
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "12px",
                color: "#666",
                whiteSpace: "nowrap"
              }}>
                {7 - files.length} more can be added
              </div>
            )}
          </div>
        )}
      </div>

      <div className="venue-inputs">
        <div className="input-form">
          <div className="input">
            <h5>
              {t("hostName")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div>
              <input
                placeholder={t("placeholderHostName")}
                type="text"
                value={state.name}
                required
                onChange={(e) => updateState("name", e.target.value)}
              />
            </div>
          </div>

          <div className="input">
            <h5>
              {t("brand")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div>
              <input
                placeholder={t("placeholderBrand")}
                type="text"
                value={state.brand}
                onChange={(e) => updateState("brand", e.target.value)}
              />
            </div>
          </div>

          <div className="input">
            <h5>
              {t("buildYear")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div
              style={
                state.year !== null &&
                (state.year > currentYear || state.year < 1800)
                  ? { border: "1px solid red" }
                  : {}
              }
            >
              <input
                placeholder={t("placeholderBuildYear")}
                type="text"
                value={state.year || ""}
                onChange={(e) => {
                  const v = Number(e.target.value) || 0;
                  updateState("year", v);
                }}
              />
            </div>
          </div>

          <div className="input">
            <h5>{t("guestRooms")}</h5>
            <div
              style={
                state.guest_rooms !== null && state.guest_rooms < 0
                  ? { border: "1px solid red" }
                  : {}
              }
            >
              <input
                placeholder={t("placeholderGuestRooms")}
                type="text"
                value={state.guest_rooms || ""}
                onChange={(e) => {
                  const v = Number(e.target.value) || 0;
                  updateState("guest_rooms", v);
                }}
              />
            </div>
          </div>

          <div className="input">
            <h5>
              {t("capacity")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div
              style={
                state.capacity !== null && state.capacity < 1
                  ? { border: "1px solid red" }
                  : {}
              }
            >
              <input
                placeholder={t("placeholderCapacity")}
                type="text"
                value={state.capacity || ""}
                onChange={(e) => {
                  const v = Number(e.target.value) || 0;
                  updateState("capacity", v);
                }}
              />
            </div>
          </div>

          <div className="input">
            <h5>
              {t("size")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div
              style={
                state.size !== null && state.size < 1
                  ? { border: "1px solid red" }
                  : {}
              }
            >
              <input
                placeholder={t("placeholderSize")}
                type="text"
                value={state.size || ""}
                onChange={(e) => {
                  const v = Number(e.target.value) || 0;
                  updateState("size", v);
                }}
              />
              <span style={{ width: "100px", textAlign: "right" }}>
                {t("sqmUnit")}
              </span>
            </div>
          </div>

          <div className="input">
            <h5>
              {t("venueType")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div>
              <select
                value={state.venue_type_id}
                style={
                  state.venue_type_id
                    ? { cursor: "pointer" }
                    : { color: "#888888", cursor: "pointer" }
                }
                onChange={(e) => updateState("venue_type_id", e.target.value)}
              >
                <option style={{ color: "#888888" }} value="">
                  {t("selectType")}
                </option>
                {venueTypesList.map((vt) => (
                  <option key={vt.id} value={vt.id} style={{ color: "black" }}>
                    {getLangFromLocalStorage() === "ar" && vt.title_ar ? vt.title_ar : vt.title}
                  </option>
                ))}
              </select>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 16.8C11.3 16.8 10.6 16.53 10.07 16L3.55002 9.48001C3.26002 9.19001 3.26002 8.71001 3.55002 8.42001C3.84002 8.13001 4.32002 8.13001 4.61002 8.42001L11.13 14.94C11.61 15.42 12.39 15.42 12.87 14.94L19.39 8.42001C19.68 8.13001 20.16 8.13001 20.45 8.42001C20.74 8.71001 20.74 9.19001 20.45 9.48001L13.93 16C13.4 16.53 12.7 16.8 12 16.8Z"
                  fill="#292D32"
                />
              </svg>
            </div>
          </div>

          <div className="input">
            <h5>
              {t("stepThree.eventTypesTitle") || "Event types"}
            </h5>
            <MultiSelectDropdown
              options={eventTypesList.map((et) => {
                const lang = getLangFromLocalStorage();
                const label = lang === "ar" && et.title_ar ? et.title_ar : et.title;
                return { value: et.id, label: label || String(et.id) };
              })}
              value={selectedEventTypes}
              onChange={setSelectedEventTypes}
              placeholder={t("stepThree.eventTypesSubtitle") || "Select event types"}
            />
          </div>

          <div className="input">
            <h5>
              {t("country")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div>
              <select
                value={state.country}
                style={
                  state.country
                    ? { cursor: "pointer" }
                    : { color: "#888888", cursor: "pointer" }
                }
                onChange={(e) => updateState("country", e.target.value)}
              >
                <option style={{ color: "#888888" }} value="">
                  {t("selectCountry")}
                </option>
                {countries.map((country) => (
                  <option key={country.id} value={country.id} style={{ color: "black" }}>
                    {t(`countries.${country.name}`)}
                  </option>
                ))}
              </select>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 16.8C11.3 16.8 10.6 16.53 10.07 16L3.55002 9.48001C3.26002 9.19001 3.26002 8.71001 3.55002 8.42001C3.84002 8.13001 4.32002 8.13001 4.61002 8.42001L11.13 14.94C11.61 15.42 12.39 15.42 12.87 14.94L19.39 8.42001C19.68 8.13001 20.16 8.13001 20.45 8.42001C20.74 8.71001 20.74 9.19001 20.45 9.48001L13.93 16C13.4 16.53 12.7 16.8 12 16.8Z"
                  fill="#292D32"
                />
              </svg>
            </div>
          </div>

          <div className="input">
            <h5>
              {t("city")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div>
              <select
                value={state.city || ""}
                disabled={!state.country}
                style={
                  state.city
                    ? { cursor: "pointer" }
                    : { color: "#888888", cursor: "pointer" }
                }
                onChange={(e) => {
                  const id = e.target.value
                    ? parseInt(e.target.value, 10)
                    : null;
                  updateState("city", id);
                  const cityName = cities.find((city) => city.id === id)?.name || "";
                  setSearchCity(cityName);
                  // Update location name when city is selected
                  setLocationName(cityName);
                }}
              >
                <option style={{ color: "#888888" }} value="">
                  {t("selectCity")}
                </option>
                {cities.map((city) => (
                  <option
                    key={city.id}
                    value={city.id}
                    style={{ color: "black" }}
                  >
                    {city.name}
                  </option>
                ))}
                {/* <option key={city.id} value={city.id}>
              {city.name}
            </option> */}
              </select>

              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 16.8C11.3 16.8 10.6 16.53 10.07 16L3.55002 9.48001C3.26002 9.19001 3.26002 8.71001 3.55002 8.42001C3.84002 8.13001 4.32002 8.13001 4.61002 8.42001L11.13 14.94C11.61 15.42 12.39 15.42 12.87 14.94L19.39 8.42001C19.68 8.13001 20.16 8.13001 20.45 8.42001C20.74 8.71001 20.74 9.19001 20.45 9.48001L13.93 16C13.4 16.53 12.7 16.8 12 16.8Z"
                  fill="#292D32"
                />
              </svg>
            </div>
          </div>

          <div className="terms">
            <h5>
              {t("termsConditions")} <span style={{ color: "red" }}>*</span>
            </h5>
            <div className="terms">
              <textarea
                value={state.terms}
                onChange={(e) => updateState("terms", e.target.value)}
                maxLength={1000}
              />
            </div>
          </div>
        </div>

        <div className="input-location">
          <MapComponent 
            center={center} 
            setCenter={setCenter} 
            searchCity={searchCity}
            locationName={locationName}
            setLocationName={setLocationName}
            // onLocationSelect={(locationName) => {
            //   // Update location name when selected from map
            //   setLocationName(locationName);
            // }}
          />
        </div>
      </div>

      <div className="buttons">
        <button className="Cancel" onClick={() => navigate("/venues")}>
          {t("cancel")}
        </button>
        <button
          style={
            confirm() && status !== "loading" && !isUploadingFiles
              ? {}
              : { background: "#888888" }
          }
          className="Next"
          onClick={() => {
            if (!confirm() || isUploadingFiles || status === "loading") return;
            if (state.name.length < 3) {
              alert(t("nameTooShort"));
              return;
            }
            if (state.brand.length < 3) {
              alert(t("brandTooShort"));
              return;
            }
            if (editVenue) {
              // Get selected event types from localStorage
              const getSelectedEventTypes = () => {
                try {
                  const saved = localStorage.getItem("selectedEventTypes");
                  return saved ? JSON.parse(saved) : [];
                } catch (error) {
                  console.error("Failed to load selected event types:", error);
                  return [];
                }
              };
              const savedEventTypes = getSelectedEventTypes();
              update(null, null, state, null, id, null, savedEventTypes);
            } else {
              handleNavigateWithParams(2);
            }
          }}
        >
          {editVenue
            ? status === "loading"
              ? t("loading")
              : isUploadingFiles
              ? t("processing")
              : t("save")
            : isUploadingFiles
            ? t("processing")
            : t("next")}
        </button>
      </div>

      {status === "Success" && (
        <div className="message_Venue">
          <div>
            <Success />
            {t("changesSaved")}
          </div>
        </div>
      )}

      <ToastContainer />

      {/* Focus point selector overlay */}
      {focusOverlay.show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 50,
            padding: "16px",
            paddingTop: "100px",
          }}
          onClick={closeFocusSelector}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "16px",
              padding: "24px",
              maxWidth: "1792px",
              maxHeight: "90vh",
              width: "100%",
              overflowY: "auto"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <h3 style={{ 
                margin: 0, 
                fontSize: "18px", 
                fontWeight: "600", 
                color: "#1f2937" 
              }}>
                {t("setFocusPoint") || "Set focus point"}
              </h3>
              <button
                onClick={closeFocusSelector}
                style={{
                  color: "#6b7280",
                  backgroundColor: "transparent",
                  border: "none",
                  padding: "4px",
                  cursor: "pointer",
                  fontSize: "24px",
                  lineHeight: 1,
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="18"
                    y1="6"
                    x2="6"
                    y2="18"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <line
                    x1="6"
                    y1="6"
                    x2="18"
                    y2="18"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </button>
            </div>

            <p style={{ 
              fontSize: "14px", 
              color: "#4b5563", 
              marginBottom: "16px" 
            }}>
              {t("focusPointInstructions") || "Click or drag on the image to set the focus point. This will determine how the image is cropped in different layouts."}
            </p>

            {/* Image Preview Container */}
            <div style={{ marginBottom: "24px" }}>
              <div
                ref={overlayRef}
                style={{
                  position: "relative",
                  margin: "0 auto",
                  border: "2px solid #d1d5db",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                  userSelect: "none",
                  cursor: isDragging ? "grabbing" : "grab",
                  width: Math.min(TARGET_WIDTH, window.innerWidth - 100),
                  height: Math.min(
                    TARGET_HEIGHT,
                    (window.innerWidth - 100) / TARGET_ASPECT_RATIO
                  ),
                  maxWidth: "100%",
                }}
                onMouseDown={handleMouseDown}
                onTouchStart={handleTouchStart}
              >
                <img
                  src={focusOverlay?.image}
                  alt="Focus selection"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    pointerEvents: "none",
                    objectPosition: `${focusPoint.x}% ${focusPoint.y}%`,
                  }}
                  draggable={false}
                />

                {/* Focus Point Indicator */}
                <div
                  style={{
                    position: "absolute",
                    left: `${focusPoint.x}%`,
                    top: `${focusPoint.y}%`,
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#3b82f6",
                    borderRadius: "50%",
                    transform: "translate(-50%, -50%)",
                    border: "4px solid white",
                    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                    pointerEvents: "none",
                    transition: "all 0.15s",
                    ...(isDragging ? { 
                      transform: "translate(-50%, -50%) scale(1.25)",
                      animation: "pulse 1s infinite"
                    } : {})
                  }}
                />

                {/* Crosshair */}
                <div
                  style={{
                    position: "absolute",
                    left: `${focusPoint.x}%`,
                    top: `${focusPoint.y}%`,
                    transform: "translate(-50%, -50%)",
                    pointerEvents: "none",
                  }}
                >
                  <div
                    style={{
                      height: "2px",
                      backgroundColor: "white",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                      transition: "all 0.15s",
                      width: isDragging ? "48px" : "32px",
                      transform: "translateX(-50%)"
                    }}
                  ></div>
                  <div
                    style={{
                      width: "2px",
                      backgroundColor: "white",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                      transition: "all 0.15s",
                      height: isDragging ? "48px" : "32px",
                      transform: "translateY(-50%) translateX(-50%)"
                    }}
                  ></div>
                </div>

                {/* Drag instruction overlay */}
                {!isDragging && (
                  <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    transition: "background-color 0.2s"
                  }}>
                    <div style={{
                      backgroundColor: "rgba(0, 0, 0, 0.6)",
                      color: "white",
                      padding: "4px 12px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      opacity: 0,
                      transition: "opacity 0.2s"
                    }}>
                      {t("dragClick") || "Click or drag to set focus point"}
                    </div>
                  </div>
                )}
              </div>

              <div style={{
                textAlign: "center",
                marginTop: "8px",
                fontSize: "14px",
                color: "#6b7280"
              }}>
                Focus point: {Math.round(focusPoint.x)}%, {Math.round(focusPoint.y)}%
                {isDragging && (
                  <span style={{ 
                    marginLeft: "8px", 
                    color: "#3b82f6", 
                    fontWeight: "500" 
                  }}>
                    Dragging...
                  </span>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-end"
            }}>
              <button
                onClick={handleResetFocus}
                style={{
                  padding: "8px 24px",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                  fontSize: "14px"
                }}
              >
                {t("reset") || "Reset"}
              </button>
              <button
                onClick={closeFocusSelector}
                style={{
                  padding: "8px 24px",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                  fontSize: "14px"
                }}
              >
                {t("cancel") || "Cancel"}
              </button>
              <button
                onClick={closeFocusSelector}
                style={{
                  padding: "8px 24px",
                  backgroundColor: "#3b82f6",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                  fontSize: "14px"
                }}
              >
                {t("save") || "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepOne;
